import { c as _c } from "react/compiler-runtime";
import { PaymentProcessorEnum } from '@systemeio/ui';
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { PaypalSoapPaymentIntegrationInterface } from '../../paypal-soap/types';
import { PaypalIntegrationTypeInterface, PaypalRestPaymentIntegrationInterface } from '../types';
const showBoth = (id: number | undefined) => id ? [2251, 11479052, 9733734, 4128396, 11045017].includes(id) : false;
export const usePaypalIntegrationType = () => {
  const $ = _c(16);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  const {
    getConnectedPaymentIntegration
  } = useConnectedPaymentIntegrations();
  let t1;
  if ($[1] !== getConnectedPaymentIntegration) {
    t1 = getConnectedPaymentIntegration({
      processor: PaymentProcessorEnum.PaypalRest
    });
    $[1] = getConnectedPaymentIntegration;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const paypalRestIntegration = t1;
  let t2;
  if ($[3] !== getConnectedPaymentIntegration) {
    t2 = getConnectedPaymentIntegration({
      processor: PaymentProcessorEnum.PaypalSoap
    });
    $[3] = getConnectedPaymentIntegration;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const paypalSoapIntegration = t2;
  const hasPaypalIntegration = !!paypalRestIntegration || !!paypalSoapIntegration;
  const {
    data
  } = useControlledSwr("/secure/paypal/get-integration-type", fetcher, undefined, !hasPaypalIntegration);
  let t3;
  if ($[5] !== data?.integrationType || $[6] !== paypalRestIntegration || $[7] !== user?.id) {
    t3 = !!paypalRestIntegration || data?.integrationType === PaymentProcessorEnum.PaypalRest || showBoth(user?.id);
    $[5] = data?.integrationType;
    $[6] = paypalRestIntegration;
    $[7] = user?.id;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== data?.integrationType || $[10] !== paypalSoapIntegration || $[11] !== user?.id) {
    t4 = !!paypalSoapIntegration || data?.integrationType === PaymentProcessorEnum.PaypalSoap || showBoth(user?.id);
    $[9] = data?.integrationType;
    $[10] = paypalSoapIntegration;
    $[11] = user?.id;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t3 || $[14] !== t4) {
    t5 = {
      shouldShowRest: t3,
      shouldShowSoap: t4
    };
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};